const createQuery = () => `
... on CtaWidget {
  text
  link
  secondaryText
  secondaryLink
}
`
export default createQuery
